<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form :model="queryParams" ref="queryParams" size="small" label-width="80px">
          <el-row :gutter="24" type="flex">
            <el-col :span="4">
              <el-form-item label="设备名称">
                <el-input v-model="queryParams.EQP_TEMP_NAME" placeholder="请输入设备名称" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="识别码">
                <el-input v-model="queryParams.OIDNO" placeholder="请输入设备识别码" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="使用单位">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="小区名称">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="检测人员">
                <el-input v-model="queryParams.testEmployeeName" placeholder="请输入检测人员" clearable @keyup.enter.native="handleSearch" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4">
              <el-form-item label="状态">
                <el-select v-model="queryParams.reportStates" placeholder="请选择状态" clearable style="width: 100%;">
                  <el-option label="待审核" value="Check"></el-option>
                  <el-option label="已审核" value="Audit"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="24" type="flex">

          </el-row>
          <div style="text-align: center; margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReview="handleReview" @handleReturn="handleReturn" @handleBatchPrint="handleBatchPrint" />
          </div>
          <!-- 表格 -->
          <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" v-loading="loading"
                    element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" row-key="id" @selection-change="handleSelectionChange"
                    height="500">
            <el-table-column type="selection" width="60" align="left" fixed="left"></el-table-column>
            <el-table-column type="index" label="序号" width="60" align="left" fixed="left" :index="indexMethod"></el-table-column>
            <el-table-column label="检测日期" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="提交时间" align="left" prop="batch_submit_time" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="检测人" align="left" prop="testEmployeeName" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="设备名称" align="left" prop="EQP_TEMP_NAME" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="设备代码" align="left" prop="OIDNO" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="内部编号" align="left" prop="EQP_INNER_COD" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="审核人" align="left" prop="auditEmployeePid" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="审核日期" align="left" prop="auditDate" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="委托单编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" align="left" prop="reportState" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.reportState)">
                  {{ getStatusText(scope.row.reportState) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="520" fixed="right">
              <template slot-scope="scope">
                <!-- <el-button type="text" size="small" @handleEquipmentInfo="handleEquipmentInfo(scope.row)">设备信息</el-button>
                <el-button type="text" size="small" @handleMemoDetail="handleMemoDetail(scope.row)">备忘录详情</el-button>
                <el-button type="text" size="small" @handleRectificationDetail="handleRectificationDetail(scope.row)">整改详情</el-button> -->
                <PermissionMethodRow :url="url" :id="'rowtoolbar'" :row="scope.row" @handleEquipmentInfo="handleEquipmentInfo(scope.row)" @handleMemoDetail="handleMemoDetail(scope.row)"
                                     @handleRectificationDetail="handleRectificationDetail(scope.row)" @handlePDF="handlePDF(scope.row)" @handleViewSingle="handleViewSingle(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currPage" :page-sizes="[10, 20, 50, 100,200,500]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-form>
      </el-col>
    </el-row>

    <!-- 批量退回对话框 -->
    <el-dialog title="批量退回报告" :visible.sync="returnDialogVisible" width="600px" :before-close="closeReturnDialog">
      <el-form :model="returnForm" ref="returnForm" label-width="120px" :rules="returnRules">
        <el-alert title="提示" :description="`您已选择 ${selectedRows.length} 条报告，请输入退回原因`" type="info" :closable="false" style="margin-bottom: 20px;">
        </el-alert>
        <el-form-item label="退回原因" prop="returnReason">
          <el-input v-model="returnForm.returnReason" type="textarea" :rows="4" placeholder="请输入退回原因" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReturnDialog">取 消</el-button>
        <el-button type="danger" @click="confirmReturn" :loading="returnLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量审核日期对话框 -->
    <el-dialog title="批量审核" :visible.sync="batchReviewDialogVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="审核时间">
          <el-date-picker v-model="batchReviewDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择审核时间" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchReviewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchReview" :loading="reviewLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- PDF预览对话框 -->
    <el-dialog title="预览" :visible.sync="pdfPreviewVisible" width="80%" append-to-body>
      <PdfImgViewer ref="pdfImgViewer" :fileName="pdfFileName" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 视频播放对话框 -->
    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="800px" :before-close="closeVideoDialog" :close-on-click-modal="false">
      <div class="video-container">
        <video v-if="currentVideoUrl" ref="videoPlayer" :src="currentVideoUrl" controls width="100%" style="max-height: 500px;">
          您的浏览器不支持视频播放
        </video>
        <div v-else class="no-video">
          <i class="el-icon-video-camera" style="font-size: 48px; color: #ccc;"></i>
          <p style="color: #999; margin-top: 10px;">暂无视频</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeVideoDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <EquipmentConfirmDialog ref="equipmentConfirmDialog" />
    <Rectification ref="rectificationDialog" />

  </div>
</template>

<script>
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';
import EquipmentConfirmDialog from '../OriginalManagement/EquipmentConfirmDialog.vue';
import Rectification from '../rectificationItem/rectification.vue';
import { queryTestDataAuditList, testDataAudit, testDataOperatorBack, previewTestDataPdf } from '@/api/contract/contract';

export default {
  name: 'ReportReview',
  components: {
    PdfImgViewer,
    EquipmentConfirmDialog,
    Rectification
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 表格数据
      tableData: [],
      // 选中的行
      selectedRows: [],
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 200,
        EQP_TEMP_NAME: undefined,
        OIDNO: undefined,
        usingUnit: undefined,
        entrustNum: undefined,
        reportNum: undefined,
        reportStates: 'Check' // 默认待审核
      },
      // 审核加载状态
      reviewLoading: false,
      // 退回对话框
      returnDialogVisible: false,
      returnForm: {
        returnReason: ''
      },
      returnRules: {
        returnReason: [
          { required: true, message: '请输入退回原因', trigger: 'blur' }
        ]
      },
      returnLoading: false,
      // 批量审核日期
      batchReviewDialogVisible: false,
      batchReviewDate: '',
      // PDF预览相关
      pdfPreviewVisible: false,
      pdfFileName: '',
      // 视频播放相关
      videoDialogVisible: false,
      currentVideoUrl: ''
    };
  },
  created () {
    this.getList();
  },
  methods: {
    // 计算序号（考虑分页）
    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1;
    },
    // 获取状态文本
    getStatusText (status) {
      switch (status) {
        case 'Check':
          return '待审核';
        case 'Audit':
          return '已审核';
        default:
          return '未知';
      }
    },
    // 获取状态标签类型
    getStatusType (status) {
      switch (status) {
        case 'Check':
          return 'warning';
        case 'Audit':
          return 'success';
        default:
          return 'info';
      }
    },
    // 查询列表
    getList () {
      this.loading = true;

      queryTestDataAuditList(this.queryParams).then(res => {
        if (res && res.retCode === 'ok' && res.additionalData) {
          const { records = [], current = this.queryParams.currPage, size = this.queryParams.pageSize, total = 0 } = res.additionalData || {};
          this.tableData = records;
          this.queryParams.currPage = current;
          this.queryParams.pageSize = size;
          this.total = total;
        } else {
          this.$message.error((res && res.retMsg) || '获取报告列表失败');
        }
        this.loading = false;
      }).catch(error => {
        console.error('获取报告列表失败:', error);
        this.loading = false;
        this.$message.error('获取报告列表失败');
      });
    },
    // 表格选择改变
    handleSelectionChange (selection) {
      this.selectedRows = selection;
    },
    // 搜索按钮
    handleSearch () {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置按钮
    handleReset () {
      this.queryParams = {
        currPage: 1,
        pageSize: 200,
        EQP_TEMP_NAME: undefined,
        OIDNO: undefined,
        usingUnit: undefined,
        entrustNum: undefined,
        reportNum: undefined,
        reportStates: 'Check'
      };
      this.getList();
    },
    // 审核按钮（批量）
    handleReview () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据进行审核');
        return;
      }
      this.batchReviewDate = this.getNowDateTime();
      this.batchReviewDialogVisible = true;
    },
    // 批量审核日期弹窗确认
    confirmBatchReview () {
      const finalAuditDate = this.batchReviewDate || this.getNowDateTime();
      this.batchReviewDialogVisible = false;
      this.confirmReview(false, finalAuditDate);
    },
    // 确认审核（批量）
    confirmReview (forceSubmit = false, auditDate = '') {
      const finalAuditDate = auditDate || this.getNowDateTime();
      const invalidRows = this.selectedRows.filter(row => row.testEmployeeDate && row.testEmployeeDate > finalAuditDate);

      if (invalidRows.length > 0) {
        const invalidMessage = invalidRows.map((row, index) => `${index + 1}. ${row.entrustNum || row.id}（检测日期：${row.testEmployeeDate}）`).join('<br/>');
        this.$alert(`以下数据的检测日期晚于审核日期（${finalAuditDate}），无法审核：<br/><br/>${invalidMessage}`, '审核日期校验失败', {
          dangerouslyUseHTMLString: true
        });
        return;
      }

      this.reviewLoading = true;

      // 构建批量审核参数
      const params = this.selectedRows.map(row => ({
        id: row.id,
        entrustNum: row.entrustNum,
        optType: 'Audit',
        forceSubmit: forceSubmit,
        auditDate: finalAuditDate
      }));

      testDataAudit(params).then(res => {
        this.reviewLoading = false;
        if (res && res.retCode === 'ok') {
          this.$message.success('审核成功');
          this.getList();
        } else if (res && res.retCode === '40013') {
          // 客户未签名，弹出确认对话框
          const noSignatureList = res.additionalData || [];
          let message = '客户未签名，是否确认提交？';

          if (noSignatureList.length > 0) {
            message = '以下委托单客户未签名，是否确认提交？<br/><br/>';
            message += noSignatureList.map((entrustNum, index) => `${index + 1}. ${entrustNum}`).join('<br/>');
          }

          this.$confirm(message, '提示', {
            confirmButtonText: '确认提交',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              // 用户确认，强制提交
              this.confirmReview(true, finalAuditDate);
            })
            .catch(() => {
              // 用户取消
              this.$message.info('已取消审核');
            });
        } else {
          this.$message.error((res && res.retMsg) || '审核失败');
        }
      }).catch(error => {
        console.error('审核失败:', error);
        this.$message.error('审核失败');
        this.reviewLoading = false;
      });
    },
    // 退回按钮（批量）
    handleReturn () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一条数据进行退回');
        return;
      }

      // 打开退回对话框，用于输入退回原因
      this.returnForm = {
        returnReason: ''
      };
      this.returnDialogVisible = true;
    },
    // 关闭退回对话框
    closeReturnDialog () {
      this.returnDialogVisible = false;
      this.$refs.returnForm.resetFields();
    },
    // 确认退回（批量）
    confirmReturn () {
      this.$refs.returnForm.validate((valid) => {
        if (valid) {
          this.returnLoading = true;

          // 构建批量退回参数
          const params = this.selectedRows.map(row => ({
            id: row.id,
            entrustNum: row.entrustNum,
            optType: 'Back',
            backReason: this.returnForm.returnReason
          }));

          testDataOperatorBack(params).then(res => {
            if (res && res.retCode === 'ok') {
              this.$message.success('退回成功');
              this.closeReturnDialog();
              this.getList();
            } else {
              this.$message.error((res && res.retMsg) || '退回失败');
            }
            this.returnLoading = false;
          }).catch(error => {
            console.error('退回失败:', error);
            this.$message.error('退回失败');
            this.returnLoading = false;
          });
        }
      });
    },
    // 分页大小改变
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.queryParams.currPage = val;
      this.getList();
    },
    // 批量打印
    handleBatchPrint () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要打印的报告');
        return;
      }

      // 提取所有选中行的委托编码
      const entrustNums = this.selectedRows.map(row => row.entrustNum).filter(num => num);

      if (entrustNums.length === 0) {
        this.$message.warning('选中的数据中没有有效的委托编码');
        return;
      }

      // 弹出对话框询问用户选择打印类型
      this.$msgbox({
        title: '提示',
        message: '请选择需要打印的数据',
        showCancelButton: true,
        confirmButtonText: '报告',
        cancelButtonText: '记录',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            // 用户点击"报告"按钮，type=0
            this.generatePdf(entrustNums, 0);
            done();
          } else if (action === 'cancel') {
            // 用户点击"记录"按钮，type=1
            this.generatePdf(entrustNums, 1);
            done();
          } else {
            done();
          }
        }
      }).catch(() => {
        // 用户关闭对话框，不做任何操作
      });
    },
    // 生成PDF
    generatePdf (entrustNums, type) {
      // 显示全屏遮罩层
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用批量生成PDF的API
      previewTestDataPdf({ entrustNums: entrustNums, type: type }).then(response => {
        console.log(response);
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 设置PDF文件名并打开预览弹窗
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$nextTick(() => {
            if (this.$refs.pdfImgViewer) {
              this.$refs.pdfImgViewer.init();
            }
          });
          const typeText = type === 0 ? '报告' : '记录';
          this.$message.success(`${typeText}PDF生成成功`);
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('生成PDF失败:', error);
        loading.close();
        this.$message.error('生成PDF失败');
      });
    },
    handleEquipmentInfo (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$refs.equipmentConfirmDialog && this.$refs.equipmentConfirmDialog.show(row, 'view');
    },
    handleMemoDetail (row) {
      if (!row.memoFileUUID) {
        this.$message.warning('文件不存在');
        return;
      }
      this.pdfFileName = row.memoFileUUID;
      this.pdfPreviewVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pdfImgViewer) {
          this.$refs.pdfImgViewer.init();
        }
      });
    },
    handleRectificationDetail (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('委托单编号不能为空');
        return;
      }
      this.$refs.rectificationDialog && this.$refs.rectificationDialog.openDialog(row, { mode: 'view' });
    },
    handlePDF (row) {
      if (!row || !row.entrustNum) {
        this.$message.warning('缺少委托编号');
        return;
      }
      this.$confirm('请选择要查看的内容：', '选择打印类型', {
        distinguishCancelAndClose: true,
        confirmButtonText: '原始记录',
        cancelButtonText: '报告',
        type: 'info'
      }).then(() => {
        this.callPreviewAPI(row.entrustNum, 1);
      }).catch(action => {
        if (action === 'cancel') {
          this.callPreviewAPI(row.entrustNum, 0);
        }
      });
    },
    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        loading.close();
        if (response && response.retCode === 'ok' && response.additionalData) {
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$nextTick(() => {
            if (this.$refs.pdfImgViewer) {
              this.$refs.pdfImgViewer.init();
            }
          });
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },
    handleViewSingle (row) {
      if (!row.videoFileUrl) {
        this.$message.warning('该记录暂无视频文件');
        return;
      }
      this.currentVideoUrl = row.videoFileUrl;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(error => {
            console.error('自动播放失败:', error);
          });
        }
      });
    },
    closeVideoDialog () {
      this.videoDialogVisible = false;
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
          this.$refs.videoPlayer.currentTime = 0;
        }
        this.currentVideoUrl = '';
      });
    },
    getNowDateTime () {
      const date = new Date();
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      const hour = `${date.getHours()}`.padStart(2, '0');
      const minute = `${date.getMinutes()}`.padStart(2, '0');
      const second = `${date.getSeconds()}`.padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.video-container {
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-video {
  text-align: center;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
